import api from '@/modules/categories/api'
import { removeEmptyChildren } from '@/modules/categories/helpers'
import { ProductSearchOptions } from '@/modules/product/types'
import { t } from '@/plugins/i18n.ts'
import { defineQueryOptions } from '@pinia/colada'

const CATEGORIES_QUERY_KEYS = {
  root: ['categories'] as const,
  products: (options: ProductSearchOptions) => [...CATEGORIES_QUERY_KEYS.root, options] as const
}

const categoriesQueryOptions = defineQueryOptions(() => ({
  key: CATEGORIES_QUERY_KEYS.root,
  query: async () => {
    const raw = await api.loadCategories()
    return removeEmptyChildren(raw.data)
  },
  // Example how to do error handling
  meta: {
    onError: {
      defaultConfigParams: {
        appearance: 'CUSTOM',
        customHandler: 'Category'
      },
      specificConfigParams: [
        {
          errorCode: 404,
          customMessage: t('error.categoriesNotFound')
        }
      ]
    }
  }
}))

export { categoriesQueryOptions, CATEGORIES_QUERY_KEYS }
